<ng-container *ngIf="permConfig.isViewAllowed">
  <div class="container-fluid">
    <app-page-title title="List Manifests"></app-page-title>
    <div class="card card-body">
      <div class="row">
        <div class="d-flex flex-wrap">
          <form [formGroup]="filterForm" *ngIf="userType != 'Customer'">
            <div ngbDropdown container="body" [autoClose]="'outside'" #dropdown="ngbDropdown">
              <button ngbDropdownToggle type="button" class="btn btn-outline-secondary btn-sm"
                style="height: 2rem;margin-left: 10px;">
                <i class="mdi mdi-filter-outline me-1"></i>Filters
                <span
                  [ngClass]="dropdown.isOpen() ? 'mdi mdi-chevron-up label-icon ms-1' : 'mdi mdi-chevron-down label-icon ms-1'"></span>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownConfig" class="dropdown-menu dropdown-menu-end">
                <div class="dropdown-item">
                  <input id="customerC" class="form-check-input me-2 pointer" type="checkbox"
                    formControlName="customerCheck" />
                  <label for="customerC" class="form-label pointer">Customer generated</label>
                </div>
                <div class="dropdown-item">
                  <input class="form-check-input" type="checkbox" id="inbound" formControlName="inboundCheck">
                  <label for="inbound" class="form-label ms-2">Inbound Shipment</label>
                </div>
                <div class="dropdown-item">
                  <input class="form-check-input" type="checkbox" id="outbound" formControlName="outboundCheck" />
                  <label class="form-label ms-2" for="outbound">Outbound Shipment</label>
                </div>
                <div class="dropdown-divider"></div>
                <div class="dropdown-header row mt-1 col-md-12" style="display: flex; justify-content: space-evenly;">
                  <button type="button" class="btn btn-primary btn-sm" style="width: 40%;"
                    (click)="dropdown.close();filterManifest()">Apply</button>
                  <button type="button" class="btn btn-outline-secondary btn-sm" style="width: 40%;"
                    (click)="filterForm.reset();dropdown.close();filterManifest()">Clear</button>
                </div>
              </div>
            </div>
          </form>
          <div class="flex-grow-1 d-flex justify-content-end align-items-center">
            <a routerLink="bagging"><button type="button" class="btn btn-secondary btn-sm me-2"><i
                  class="mdi mdi-plus me-1"></i>Bagging</button></a>
            <a routerLink="add"><button type="button" class="btn btn-success btn-sm"><i
                  class="mdi mdi-plus mr-1 me-1"></i>Add Manifest</button></a>
          </div>
        </div>
      </div>
    </div>
    <div class="card card-body">
      <div class="col-md-12 grid-container mb-2">
        <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
          [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
          [defaultColDef]="defaultColDef" [suppressMenuHide]="true" [pagination]="true"
          (gridReady)="onGridReady($event)" [gridOptions]="gridOptions">
        </ag-grid-angular>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
  <app-forbidden></app-forbidden>
</ng-container>